export const InvestorNameField = ({ data }: { data: any }) => {
    const contactData = data?.contact;
    return (
        <span>
            {contactData.firstName} {contactData.lastName}
        </span>
    );
};
